import { APIClient } from "../api";

export default class WorkTeamService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async GetWorkTeambyUser(userId: number) {
        const url = `${this.endpoint}/WorkTeam/GetWorkTeams/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetUserManager(userId: number) {
        const url = `${this.endpoint}/WorkTeam/GetUserManager/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async GetWorkTeambyUserCustomerId(userId: number, customerId: string, profile?: string) {
        const url = `${this.endpoint}/WorkTeam/GetWorkTeamsbyCustomer/${userId}/${customerId}/?profile=${profile ?? 0}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getWorkTeamByBusinessArea(idBusinessArea: number) {
        const url = `${this.endpoint}/WorkTeam?$filter=IdBusinessArea eq ${idBusinessArea} and Disabled eq 0`;

        return (await this.api({
            method: 'get',
            url
        })).data;
    }

}